<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <!-- HEADER -->
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <router-link to="/" class="flex items-center gap-2 cursor-pointer">
          <img src="/brand/getlance-logo.svg" alt="Logo GetLance" class="h-20 w-auto" />
        </router-link>
        <div class="flex gap-3">
          <router-link to="/login"
            class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition whitespace-nowrap text-sm">
            Já tenho conta
          </router-link>
        </div>
      </div>
    </header>

    <!-- SPLIT-SCREEN -->
    <section class="flex-1 flex flex-col lg:flex-row">
      <!-- ====================================================== -->
      <!-- LEFT — Painel de marca / proposta de valor (desktop)   -->
      <!-- ====================================================== -->
      <aside class="hidden lg:flex lg:w-[42%] xl:w-2/5 relative overflow-hidden
                    bg-gradient-to-br from-[#152a34] via-[#1a3543] to-[#0f1f27] text-white p-12 xl:p-16 flex-col justify-center">
        <!-- Background decor -->
        <div class="absolute inset-0 opacity-30 pointer-events-none"
          style="background-image: radial-gradient(circle at 20% 20%, #b99a52 0%, transparent 40%), radial-gradient(circle at 80% 80%, #b99a52 0%, transparent 40%);">
        </div>

        <div class="relative">
          <span class="inline-flex items-center gap-2 px-3 py-1 rounded-full
                       bg-[#b99a52]/15 border border-[#b99a52]/40 text-[#e6d4a3] text-[11px] font-semibold tracking-wider uppercase mb-8">
            <span class="w-1.5 h-1.5 rounded-full bg-[#b99a52]"></span>
            Marketplace GetLance
          </span>

          <h1 class="text-3xl xl:text-4xl font-extrabold leading-tight mb-4">
            Cadastre-se grátis em <span class="text-[#b99a52]">menos de 1 minuto</span>
          </h1>
          <p class="text-white/80 mb-10 text-base leading-relaxed">
            Comece a publicar projetos, encontrar trabalho remoto ou contratar
            profissionais presenciais com segurança.
          </p>

          <ul class="space-y-4 text-[15px]">
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#b99a52] text-[#152a34] items-center justify-center text-xs font-bold flex-shrink-0">✓</span>
              <span class="text-white/90"><strong class="text-white">Cadastro 100% gratuito</strong> — sem cartão de crédito</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#b99a52] text-[#152a34] items-center justify-center text-xs font-bold flex-shrink-0">✓</span>
              <span class="text-white/90"><strong class="text-white">Pagamento com garantia</strong> — liberado só após aprovação</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#b99a52] text-[#152a34] items-center justify-center text-xs font-bold flex-shrink-0">✓</span>
              <span class="text-white/90"><strong class="text-white">Chat integrado</strong> com profissionais verificados</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#b99a52] text-[#152a34] items-center justify-center text-xs font-bold flex-shrink-0">✓</span>
              <span class="text-white/90"><strong class="text-white">Receba propostas em minutos</strong> de freelancers qualificados</span>
            </li>
          </ul>
        </div>

      </aside>

      <!-- ====================================================== -->
      <!-- RIGHT — Formulário                                    -->
      <!-- ====================================================== -->
      <main class="flex-1 flex items-start lg:items-center justify-center px-4 sm:px-6 py-8 lg:py-12">
        <div class="w-full max-w-lg">
          <div class="bg-white rounded-2xl shadow-xl border border-[#e0dcd6] p-6 sm:p-8 overflow-hidden">
            <!-- Título -->
            <div class="mb-6">
              <h2 class="text-2xl sm:text-3xl font-bold text-[#152a34] mb-1">Criar conta</h2>
              <p class="text-gray-500 text-sm">
                Preencha os dados para começar.
                <router-link to="/login" class="text-[#b99a52] font-semibold hover:underline">
                  Já tenho conta
                </router-link>
              </p>
            </div>

            <!-- ============================ -->
            <!-- 1. EU SOU — sempre no topo  -->
            <!-- ============================ -->
            <div class="mb-5">
              <label class="block text-sm font-semibold text-[#152a34] mb-2">Eu sou:</label>
              <div class="grid grid-cols-2 gap-2 sm:gap-3">
                <button
                  v-for="opt in providerTypeOptions"
                  :key="opt.value"
                  type="button"
                  @click="setProviderType(opt.value)"
                  :aria-pressed="form.provider_type === opt.value"
                  class="flex flex-col items-center text-center gap-2 p-3 sm:p-4 rounded-xl border-2 transition focus:outline-none focus:ring-2 focus:ring-[#b99a52]"
                  :class="form.provider_type === opt.value
                    ? 'bg-[#152a34] text-white border-[#b99a52] shadow-md'
                    : 'bg-white text-[#152a34] border-gray-200 hover:border-[#b99a52] hover:bg-[#fdfaf3]'"
                >
                  <span class="mdi text-2xl sm:text-3xl leading-none"
                    :class="[opt.icon, form.provider_type === opt.value ? 'text-[#b99a52]' : 'text-[#152a34]']"
                  ></span>
                  <span class="text-[11px] sm:text-xs font-bold leading-tight">{{ opt.shortLabel }}</span>
                  <span class="text-[10px] sm:text-[11px] leading-snug opacity-80 hidden sm:block">
                    {{ opt.shortDescription }}
                  </span>
                </button>
              </div>
              <p class="text-xs text-gray-500 mt-2.5 px-1 leading-relaxed min-h-[2.5rem]">
                {{ currentProviderTypeDescription }}
              </p>
            </div>

            <!-- CEP condicional — vinculado à escolha "Presencial" -->
            <transition name="slide-down">
              <div v-if="needsCep" class="mb-5 p-4 bg-[#f6f4f1] border border-[#e0dcd6] rounded-xl">
                <label class="block text-sm font-semibold text-[#152a34] mb-1">
                  <span class="mdi mdi-map-marker text-[#b99a52] mr-1"></span>
                  Onde você atende? <span class="text-red-500">*</span>
                </label>
                <p class="text-xs text-gray-500 mb-3">
                  Como você atende presencialmente, informe o CEP da sua região. É por ele que clientes próximos encontram você na busca.
                </p>
                <div class="flex gap-2">
                  <input
                    v-model="form.zipCode"
                    @input="onCepInput"
                    @blur="onCepBlur"
                    type="text"
                    placeholder="00000-000"
                    maxlength="9"
                    inputmode="numeric"
                    class="input-gold flex-1"
                    :class="cepError ? 'border-red-400' : (form.service_address ? 'border-green-500' : '')"
                  />
                  <button
                    type="button"
                    @click="fetchCep"
                    :disabled="cepLoading"
                    class="px-4 bg-[#152a34] text-white rounded-xl text-sm hover:bg-[#0f1f27] transition disabled:opacity-60 flex items-center justify-center min-w-[48px]"
                    aria-label="Buscar CEP"
                  >
                    <span v-if="cepLoading" class="mdi mdi-loading animate-spin text-lg"></span>
                    <span v-else class="mdi mdi-magnify text-lg"></span>
                  </button>
                </div>
                <p v-if="cepError" class="text-red-500 text-xs mt-2">{{ cepError }}</p>

                <div v-if="form.service_address"
                  class="mt-3 p-3 bg-white rounded-xl text-xs text-[#152a34] border border-green-200 flex items-start gap-2">
                  <span class="mdi mdi-check-circle text-green-500 text-base shrink-0 mt-0.5"></span>
                  <div>
                    <p class="font-semibold mb-0.5">Endereço confirmado</p>
                    <p class="text-gray-600">
                      {{ form.service_address.address ? form.service_address.address + ', ' : '' }}{{ form.service_address.neighborhood }} — {{ form.service_address.city }}/{{ form.service_address.state }}
                    </p>
                  </div>
                </div>
              </div>
            </transition>

            <!-- ============================ -->
            <!-- 2. FORM                     -->
            <!-- ============================ -->
            <!-- Nome -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#152a34] mb-1.5">Nome completo</label>
              <div class="relative">
                <input
                  v-model="form.name"
                  type="text"
                  placeholder="Como você quer ser chamado"
                  class="input-gold pr-10"
                  :class="isNameValid ? 'border-green-500' : ''"
                />
                <span v-if="isNameValid" class="mdi mdi-check-circle text-green-500 text-xl absolute right-3 top-1/2 -translate-y-1/2"></span>
              </div>
              <p class="text-xs text-gray-400 mt-1">Pode usar nome, apelido ou marca pessoal. Pode alterar depois.</p>
            </div>

            <!-- Email -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#152a34] mb-1.5">E-mail</label>
              <div class="relative">
                <input
                  v-model="form.email"
                  type="email"
                  placeholder="seuemail@exemplo.com"
                  class="input-gold pr-10"
                  :class="emailError ? 'border-red-400' : (isEmailValid ? 'border-green-500' : '')"
                  @input="emailError = ''"
                  @blur="onEmailBlur"
                />
                <span v-if="!emailError && isEmailValid" class="mdi mdi-check-circle text-green-500 text-xl absolute right-3 top-1/2 -translate-y-1/2"></span>
                <span v-if="emailError" class="mdi mdi-alert-circle text-red-500 text-xl absolute right-3 top-1/2 -translate-y-1/2"></span>
              </div>
              <p v-if="emailError" class="text-red-500 text-xs mt-1">{{ emailError }}</p>
            </div>

            <!-- Senha -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#152a34] mb-1.5">Senha</label>
              <div class="relative">
                <input
                  v-model="form.password"
                  :type="passwordVisible ? 'text' : 'password'"
                  placeholder="Mínimo 6 caracteres"
                  class="input-gold pr-10"
                  :class="form.password && !isPasswordValid ? 'border-red-400' : (isPasswordValid ? 'border-green-500' : '')"
                />
                <button type="button" @click="passwordVisible = !passwordVisible"
                  class="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-[#152a34] transition"
                  :aria-label="passwordVisible ? 'Ocultar senha' : 'Mostrar senha'"
                >
                  <span class="mdi text-xl" :class="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"></span>
                </button>
              </div>

              <!-- Indicador de força -->
              <div v-if="form.password" class="mt-2">
                <div class="flex gap-1 mb-1">
                  <div v-for="n in 4" :key="n" class="flex-1 h-1.5 rounded-full transition-colors"
                    :class="n <= passwordStrength.score ? passwordStrength.barColor : 'bg-gray-200'">
                  </div>
                </div>
                <p class="text-xs flex items-center gap-1.5" :class="passwordStrength.textColor">
                  <span class="mdi" :class="isPasswordValid ? 'mdi-shield-check' : 'mdi-shield-alert-outline'"></span>
                  <span>{{ passwordStrength.label }}</span>
                </p>
              </div>
            </div>

            <!-- ============================ -->
            <!-- 3. SUBMIT                   -->
            <!-- ============================ -->
            <button @click="register"
              class="w-full py-3 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold transition disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
              :disabled="isSubmitting">
              <span v-if="isSubmitting" class="mdi mdi-loading animate-spin"></span>
              <span>{{ isSubmitting ? "Cadastrando..." : "Criar minha conta" }}</span>
            </button>

            <!-- DIVISOR -->
            <div class="flex items-center my-5">
              <div class="flex-grow border-t border-gray-200"></div>
              <span class="mx-3 text-gray-400 text-xs uppercase tracking-wider font-medium">ou</span>
              <div class="flex-grow border-t border-gray-200"></div>
            </div>

            <!-- ============================ -->
            <!-- 4. GOOGLE SIGNUP            -->
            <!-- ============================ -->
            <!-- Aviso CEP quando relevante para Google -->
            <transition name="fade-fast">
              <p v-if="needsCep && !form.service_address" class="text-[12.5px] text-[#6d5d3a] bg-[#f4efe6] border border-[#d6c7a5] rounded-xl px-3 py-2 mb-3 flex items-start gap-2">
                <span class="mdi mdi-information-outline text-base shrink-0 mt-0.5"></span>
                <span>Para serviços <strong>presenciais</strong>, preencha o CEP acima antes de continuar com o Google.</span>
              </p>
            </transition>

            <div>
              <div ref="googleBtnWrap" class="w-full overflow-hidden">
                <div ref="googleBtn" class="w-full flex justify-center"></div>
              </div>
            </div>

            <p class="text-center text-xs text-gray-400 mt-4 px-2 leading-relaxed">
              Ao criar conta você concorda com nossos
              <router-link to="/termos-de-servico" class="text-[#152a34] hover:underline">Termos de Serviço</router-link>
              e
              <router-link to="/politica-de-privacidade" class="text-[#152a34] hover:underline">Política de Privacidade</router-link>.
            </p>
          </div>

          <!-- Link Login (fora do card, mais leve) -->
          <p class="text-center text-sm text-gray-600 mt-5">
            Já tem conta?
            <router-link to="/login" class="text-[#b99a52] font-semibold hover:underline">
              Fazer login
            </router-link>
          </p>
        </div>
      </main>
    </section>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import api from "@/services/api";
import AppFooter from "@/components/AppFooter.vue";
import { useProviderOnboardingGuard } from "@/composables/useProviderOnboardingGuard";

const router = useRouter();
const store = useStore();
const { enforcePresentialOnboarding } = useProviderOnboardingGuard();

const GOOGLE_CLIENT_ID = "708117913743-j1tmpf9b8endvjd3im363cniugltsvjd.apps.googleusercontent.com";

const googleBtn = ref(null);
const googleBtnWrap = ref(null);

const providerTypeOptions = [
  {
    value: 'remote',
    shortLabel: 'Remoto',
    label: 'Somente Remoto',
    shortDescription: 'Projetos online',
    description: 'Participe de projetos online: clientes publicam projetos e você se candidata para fechar negócio.',
    icon: 'mdi-laptop',
  },
  {
    value: 'presential',
    shortLabel: 'Presencial',
    label: 'Somente Presencial',
    shortDescription: 'Serviços locais',
    description: 'Seja encontrado por clientes da sua região: crie um perfil com serviços, endereço e agenda de atendimento.',
    icon: 'mdi-map-marker-account',
  },
];

const form = ref({
  name: "",
  email: "",
  password: "",
  provider_type: "remote",
  zipCode: "",
  service_address: null,
  latitude: null,
  longitude: null,
});

const isSubmitting = ref(false);
const cepLoading = ref(false);
const cepError = ref("");
const emailError = ref("");
const passwordVisible = ref(false);

const needsCep = computed(() => ['presential', 'both'].includes(form.value.provider_type));

const currentProviderTypeDescription = computed(() => {
  const found = providerTypeOptions.find(o => o.value === form.value.provider_type);
  return found?.description || '';
});

// ============================
// Validações reativas
// ============================
const isNameValid = computed(() => form.value.name.trim().length >= 2);

const isEmailValid = computed(() => {
  const v = form.value.email;
  if (!v) return false;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return false;
  if (validateEmailDomainTypos(v)) return false;
  return true;
});

const isPasswordValid = computed(() => form.value.password.length >= 6);

const passwordStrength = computed(() => {
  const pwd = form.value.password || '';
  let score = 0;
  if (pwd.length >= 6) score++;
  if (pwd.length >= 10) score++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) score++;
  if (/\d/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;

  if (!pwd) return { score: 0, label: '', barColor: 'bg-gray-200', textColor: 'text-gray-400' };
  if (pwd.length < 6) return { score: 1, label: 'Muito curta — mínimo 6 caracteres', barColor: 'bg-red-500', textColor: 'text-red-500' };
  if (score <= 2) return { score: 2, label: 'Fraca — adicione letras e números', barColor: 'bg-orange-500', textColor: 'text-orange-600' };
  if (score === 3) return { score: 3, label: 'Razoável', barColor: 'bg-yellow-500', textColor: 'text-yellow-700' };
  return { score: 4, label: 'Senha forte', barColor: 'bg-green-500', textColor: 'text-green-600' };
});

function setProviderType(value) {
  form.value.provider_type = value;
}

function validateEmailDomainTypos(email) {
  const value = String(email || '').trim().toLowerCase();
  if (!value) return null;

  const badDomains = [
    { bad: '@gmail.con', good: '@gmail.com' },
    { bad: '@gmal.com', good: '@gmail.com' },
  ];

  const hit = badDomains.find(d => value.includes(d.bad));
  if (!hit) return null;

  return `Domínio de e-mail parece incorreto (${hit.bad}). Você quis dizer ${hit.good}?`;
}

function onEmailBlur() {
  emailError.value = validateEmailDomainTypos(form.value.email) || "";
}

function formatCep(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length <= 5) return digits;
  return digits.slice(0, 5) + '-' + digits.slice(5, 9);
}

function onCepInput(e) {
  form.value.zipCode = formatCep(e.target.value);
  cepError.value = "";
  form.value.service_address = null;
  form.value.latitude = null;
  form.value.longitude = null;
}

function onCepBlur() {
  const digits = form.value.zipCode.replace(/\D/g, '');
  if (digits.length === 8) fetchCep();
}

async function fetchCep() {
  const cep = form.value.zipCode.replace(/\D/g, '');
  if (cep.length !== 8) return;
  cepLoading.value = true;
  cepError.value = "";
  try {
    const { data } = await api.get(`/cep?cep=${cep}`);
    if (data && !data.erro) {
      const addr = {
        zip_code: cep,
        address: data.logradouro || '',
        neighborhood: data.bairro || '',
        city: data.localidade || '',
        state: data.uf || ''
      };
      form.value.service_address = addr;
      await geocodeAddress(addr);
    } else {
      cepError.value = "CEP não encontrado. Verifique e tente novamente.";
    }
  } catch {
    cepError.value = "Erro ao consultar o CEP.";
  } finally {
    cepLoading.value = false;
  }
}

async function geocodeAddress(addr) {
  const key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return;
  try {
    const addressStr = [addr.address, addr.neighborhood, addr.city, addr.state, 'Brasil'].filter(Boolean).join(', ');
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addressStr)}&key=${key}&language=pt-BR`;
    const res = await fetch(url);
    const data = await res.json();
    if (data.status === 'OK' && data.results?.[0]) {
      const loc = data.results[0].geometry.location;
      form.value.latitude = loc.lat;
      form.value.longitude = loc.lng;
    }
  } catch {
    // silencioso — geocode é opcional
  }
}

function validateForm() {
  const errors = [];
  const data = form.value;

  if (!data.name.trim()) errors.push("O nome é obrigatório.");
  if (!data.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))
    errors.push("E-mail inválido ou obrigatório.");
  const domainTypoError = validateEmailDomainTypos(data.email);
  if (domainTypoError) {
    emailError.value = domainTypoError;
    errors.push(domainTypoError);
  }
  if (!data.password) errors.push("A senha é obrigatória.");
  else if (data.password.length < 6)
    errors.push("A senha deve ter no mínimo 6 caracteres.");

  if (needsCep.value) {
    const cep = data.zipCode.replace(/\D/g, '');
    if (cep.length !== 8) errors.push("Informe um CEP válido com 8 dígitos.");
    else if (!data.service_address) errors.push("Aguarde a confirmação do CEP antes de continuar.");
  }

  return errors;
}

async function register() {
  const errors = validateForm();
  if (errors.length) {
    Swal.fire({
      icon: "warning",
      title: "Corrija os campos",
      html: errors.map(e => `<p>${e}</p>`).join(''),
    });
    return;
  }

  isSubmitting.value = true;

  try {
    const payload = {
      name: form.value.name,
      email: form.value.email,
      password: form.value.password,
      role: "user",
      provider_type: form.value.provider_type,
    };

    if (needsCep.value && form.value.service_address) {
      payload.service_address = form.value.service_address;
      if (form.value.latitude) payload.latitude = form.value.latitude;
      if (form.value.longitude) payload.longitude = form.value.longitude;
    }

    await api.post("/register", payload);

    await Swal.fire({
      icon: "info",
      title: "Seu cadastro está quase pronto!",
      html: `Enviamos um e-mail de confirmação.<br/><br/><b>Verifique sua caixa de entrada ou spam</b> e clique no botão para liberar sua conta.`,
      confirmButtonText: "Entendi"
    });

    router.push("/login");
  } catch (error) {
    const status = error.response?.status;
    const code = error.response?.data?.code;
    if (code === "USER_NOT_ACTIVATED") {
      Swal.fire({
        icon: "warning",
        title: "Conta pendente",
        html: `Enviamos um e-mail para <b>${form.value.email}</b>.<br/>Confira a caixa de entrada e o spam.`,
      });
      return;
    }
    if (status === 409 || code === "EMAIL_ALREADY_EXISTS") {
      Swal.fire({
        icon: "info",
        title: "E-mail já cadastrado",
        html: `O e-mail <b>${form.value.email}</b> já possui conta na GetLance.<br/><br/>
          Se você já se cadastrou, <b>faça login</b> ou confira o e-mail de confirmação (inclusive o spam).<br/><br/>
          Para testar de novo localmente, use outro e-mail ou remova o usuário no banco de dados.`,
        confirmButtonText: "Ir para login",
        showCancelButton: true,
        cancelButtonText: "Fechar",
      }).then((result) => {
        if (result.isConfirmed) router.push("/login");
      });
      return;
    }
    const errorMsg = error?.response?.data?.error || "Tente novamente mais tarde.";
    Swal.fire({ icon: "error", title: "Erro ao cadastrar", text: errorMsg });
  } finally {
    isSubmitting.value = false;
  }
}

const waitForGoogle = (timeoutMs = 5000) => {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      if (window.google?.accounts?.id) return resolve(true);
      if (Date.now() - start >= timeoutMs) return reject(new Error("timeout"));
      setTimeout(tick, 50);
    };
    tick();
  });
};

function renderGoogleButton() {
  if (!googleBtn.value || !googleBtnWrap.value) return;
  const wrapWidth = googleBtnWrap.value.clientWidth || 0;
  const buttonWidth = Math.min(360, Math.max(240, wrapWidth));
  googleBtn.value.innerHTML = "";
  window.google.accounts.id.renderButton(googleBtn.value, {
    theme: "outline",
    size: "large",
    text: "signup_with",
    shape: "pill",
    width: buttonWidth,
    logo_alignment: "left",
  });
}

onMounted(async () => {
  await nextTick();
  try {
    await waitForGoogle(5000);
  } catch {
    return;
  }
  if (!googleBtn.value || !googleBtnWrap.value) return;

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: handleGoogleCallback,
  });

  renderGoogleButton();
  window.addEventListener("resize", renderGoogleButton);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", renderGoogleButton);
});

function validateCepForGoogle() {
  if (!needsCep.value) return null;
  const data = form.value;
  const cep = data.zipCode.replace(/\D/g, "");
  if (cep.length !== 8) return "Informe um CEP válido com 8 dígitos.";
  if (!data.service_address) return "Aguarde a confirmação do CEP (clique na lupa ou saia do campo) antes de continuar com o Google.";
  return null;
}

const handleGoogleCallback = async (response) => {
  const cepErrorMsg = validateCepForGoogle();
  if (cepErrorMsg) {
    Swal.fire({
      icon: "warning",
      title: "CEP obrigatório",
      text: "Para uso presencial ou ambos, é obrigatório informar um CEP válido. Preencha o CEP acima e aguarde a confirmação antes de continuar com o Google.",
    });
    return;
  }

  try {
    isSubmitting.value = true;
    const payload = {
      credential: response.credential,
      provider_type: form.value.provider_type,
    };
    if (needsCep.value && form.value.service_address) {
      payload.service_address = form.value.service_address;
      if (form.value.latitude != null) payload.latitude = form.value.latitude;
      if (form.value.longitude != null) payload.longitude = form.value.longitude;
    }
    const result = await store.dispatch("signInWithGoogle", payload);
    if (result?.token) {
      // Para presencial/ambos, força onboarding (endereço → serviço → agenda)
      const redirected = await enforcePresentialOnboarding();
      if (redirected) return;

      router.push("/");
      return;
    }
    Swal.fire({ icon: "error", title: "Erro ao entrar com Google.", text: "Resposta inválida do servidor." });
  } catch (error) {
    const code = error.response?.data?.code;
    if (code === "USER_NOT_ACTIVATED") {
      Swal.fire({ icon: "warning", title: "Conta pendente", text: "Confira a caixa de entrada do e-mail utilizado no Google." });
      return;
    }
    Swal.fire({ icon: "error", title: "Erro ao entrar com Google.", text: error.response?.data?.error || "Tente novamente mais tarde." });
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease;
  overflow: hidden;
}
.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  max-height: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
  opacity: 1;
  max-height: 400px;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.15s ease;
}
.fade-fast-enter-from,
.fade-fast-leave-to {
  opacity: 0;
}
</style>
